import { all } from 'redux-saga/effects';

import fundingEnquiryListSaga from './list/sagas';
import fundingEnquiryUpdateStatusSaga from './updateStatus/sagas';

export default function* fundingReportSaga() {
  return yield all([fundingEnquiryListSaga(), fundingEnquiryUpdateStatusSaga()]);
}
